import * as React from "react";
export type Platform = 'supreme' | 'create'
export type Library = 'latin' | 'music'
export const PlatformContext = React.createContext<Platform>('supreme')
export const PlatformContextProvider = PlatformContext.Provider
export const PlatformContextConsumer = PlatformContext.Consumer



// WEBPACK FOOTER //
// ./src/components/context/platform.ts